import { Chart } from "chart.js";

import type { ResolvedTheme } from "../../shared/services/theme-service";

const LIGHT_DEFAULTS = { color: Chart.defaults.color, borderColor: Chart.defaults.borderColor };
const DARK_DEFAULTS = { color: "#a0acbf", borderColor: "rgba(231, 235, 241, 0.1)" };

const isDark = () => document.documentElement.dataset["bsTheme"] === "dark";

/** Scriptable chart colour for text or lines drawn on the card: the given colour in light, the body text colour in dark */
export const chartInk = (light: string) => () => (isDark() ? "#e7ebf1" : light);

/** Colour that differs per theme; call the result for plugins that draw on the canvas context, or pass it as a scriptable option */
export const chartThemed = (light: string, dark: string) => () => (isDark() ? dark : light);

export const applyChartTheme = (theme: ResolvedTheme): void => {
  Object.assign(Chart.defaults, theme === "dark" ? DARK_DEFAULTS : LIGHT_DEFAULTS);
  Object.values(Chart.instances).forEach((chart) => chart.update("none"));
};
